export function isLitePackage(profile: any) {
	return profile?.center_package_tier === 'lite';
}

function startsWithPath(path: string, prefix: string) {
	return path === prefix || path.startsWith(`${prefix}/`);
}

const LITE_LOCKED_FEATURES = [
	{
		title: 'Mở khóa tính năng trợ lý Luca AI',
		description:
			"Nâng cấp lên Luca Pro để trải nghiệm sức mạnh của AI trong việc 'đọc vị' dữ liệu học sinh, cá nhân hóa hoạt động dạy học và sẵn sàng giải đáp mọi thắc mắc chuyên môn 24/7.",
		match(path: string) {
			return startsWithPath(path, '/luca-ai-chat');
		},
	},
	{
		title: 'Mở khóa tính năng quản lý lớp nhóm',
		description:
			'Nâng cấp lên Luca Pro để quản lý báo cáo, lên kế hoạch và lịch học lớp nhóm dễ dàng hơn.',
		match(path: string) {
			return (
				startsWithPath(path, '/group-classes') ||
				startsWithPath(path, '/group-class-plans') ||
				startsWithPath(path, '/group-class') ||
				startsWithPath(path, '/report/group') ||
				startsWithPath(path, '/schedule/timeslot/group') ||
				startsWithPath(path, '/schedule/timetable/group-classes') ||
				startsWithPath(path, '/schedule/stats/student/group-class') ||
				startsWithPath(path, '/session-management/group-class')
			);
		},
	},
	{
		title: 'Mở khóa tính năng quản lý lớp bán trú',
		description:
			'Nâng cấp lên Luca Pro để quản lý báo cáo, thực đơn và lịch học bán trú dễ dàng hơn.',
		match(path: string, query: any) {
			const daycareSchedule =
				(path === '/schedule/timetable' ||
					startsWithPath(path, '/schedule/stats')) &&
				query?.type === 'daycare';
			return (
				daycareSchedule ||
				startsWithPath(path, '/daycare-class') ||
				startsWithPath(path, '/report/day-care') ||
				startsWithPath(path, '/menu') ||
				startsWithPath(path, '/schedule/timeslot/daycare') ||
				startsWithPath(path, '/schedule/stats/student/daycare') ||
				startsWithPath(path, '/session-management/daycare')
			);
		},
	},
	{
		title: 'Mở khóa tính năng quản lý học phí',
		description:
			'Nâng cấp lên Luca Pro để tạo thông báo học phí, theo dõi thanh toán và quản lý công nợ của học sinh.',
		match(path: string) {
			return startsWithPath(path, '/fee-notices');
		},
	},
	{
		title: 'Mở khóa tính năng thời khoá biểu',
		description:
			'Nâng cấp lên Luca Pro để sắp xếp thời khoá biểu và điều phối lịch học cho toàn cơ sở.',
		match(path: string) {
			return (
				startsWithPath(path, '/center-timetable') ||
				startsWithPath(path, '/timetable-student')
			);
		},
	},
	{
		title: 'Mở khóa tính năng thông báo',
		description:
			'Nâng cấp lên Luca Pro để gửi thông báo tới phụ huynh và giáo viên ngay trên Luca Education.',
		match(path: string) {
			return startsWithPath(path, '/notifications');
		},
	},
	{
		title: 'Mở khóa tính năng biểu mẫu đánh giá',
		description:
			'Nâng cấp lên Luca Pro để tạo và sử dụng biểu mẫu đánh giá cho học sinh.',
		match(path: string) {
			return (
				startsWithPath(path, '/form-evaluation') ||
				/\/record\/student\/[^/]+\/form-evaluation/.test(path)
			);
		},
	},
	{
		title: 'Mở khóa tính năng thư viện video',
		description:
			'Nâng cấp lên Luca Pro để lưu trữ và quản lý thư viện video của cơ sở.',
		match(path: string) {
			return startsWithPath(path, '/media-history');
		},
	},
	{
		title: 'Mở khóa tính năng ngày nghỉ lễ',
		description:
			'Nâng cấp lên Luca Pro để thiết lập ngày nghỉ, ngày lễ và đồng bộ lịch học của cơ sở.',
		match(path: string) {
			return startsWithPath(path, '/holiday');
		},
	},
	{
		title: 'Mở khóa tính năng sinh nhật',
		description:
			'Nâng cấp lên Luca Pro để theo dõi sinh nhật học sinh và gửi lời chúc tới phụ huynh.',
		match(path: string) {
			return startsWithPath(path, '/birthdays');
		},
	},
	{
		title: 'Mở khóa tính năng kho tài liệu',
		description:
			'Nâng cấp lên Luca Pro để lưu trữ và chia sẻ kho tài liệu của cơ sở.',
		match(path: string) {
			return startsWithPath(path, '/documents');
		},
	}, {
		title: 'Mở khóa tính năng phiếu khảo sát',
		description:
			'Nâng cấp lên Luca Pro để tạo phiếu khảo sát và gửi tới phụ huynh.',
		match(path: string) {
			return startsWithPath(path, '/survey');
		},
	},
	{
		title: 'Mở khóa tính năng lịch học',
		description:
			'Nâng cấp lên Luca Pro để quản lý lịch học và dạy theo thời khóa biểu, cùng với các chức năng quản lý chuyên cần như báo nghỉ, đổi Trị liệu viên, tạo buổi học phát sinh, v.v. Các báo cáo cũng sẽ được tạo tự động theo Thời khóa biểu.',
		match(path: string) {
			return startsWithPath(path, '/schedule/timeslot');
		},
	},
];

export function getLiteLockedFeature(path: string, query: any) {
	return (
		LITE_LOCKED_FEATURES.find((feature: any) => feature.match(path, query)) ||
		null
	);
}
